import React, { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, formatTL, extractErrorMessage } from "@/lib/api";
import { AdvancePlanTable, buildPlan, planSum } from "./AdvancePlanTable";

export const AdvancePlanModal = ({ advance, name, onClose, onSaved }) => {
  const [plan, setPlan] = useState(advance.plan?.length ? advance.plan.map((i) => ({ ...i }))
    : buildPlan(advance.toplam_tutar, advance.taksit_sayisi, advance.baslangic_yil, advance.baslangic_ay, false));
  const [saving, setSaving] = useState(false);
  const ok = Math.abs(planSum(plan) - Number(advance.toplam_tutar)) <= 0.01;
  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/advances/${advance.id}/plan`, { plan: plan.map((i) => ({ yil: i.yil, ay: i.ay, tutar: Number(i.tutar) || 0, kaynak: i.kaynak })) });
      toast.success("Taksit planı kaydedildi");
      onSaved();
    } catch (e) { toast.error(extractErrorMessage(e, "Kaydedilemedi")); } finally { setSaving(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm grid place-items-center p-4" data-testid="advance-plan-modal">
      <div className="bg-white rounded-xl shadow-xl border border-slate-200 w-full max-w-lg">
        <div className="p-4 border-b border-slate-200 flex items-center justify-between">
          <div>
            <h3 className="font-display text-base font-bold">Taksit Planı · {name}</h3>
            <div className="text-xs text-slate-500">Toplam avans {formatTL(advance.toplam_tutar)}</div>
          </div>
          <button onClick={onClose} data-testid="advance-plan-close" className="w-8 h-8 rounded-lg hover:bg-slate-100 grid place-items-center"><X size={16} /></button>
        </div>
        <div className="p-4 space-y-2">
          <div className="flex gap-2 text-[11px]">
            <button type="button" data-testid="plan-round" onClick={() => setPlan(buildPlan(advance.toplam_tutar, plan.length, plan[0].yil, plan[0].ay, true, plan[0].kaynak))}
              className="px-2 py-1 border border-slate-300 rounded font-semibold">Eşit böl · tam liraya yuvarla</button>
          </div>
          <AdvancePlanTable plan={plan} setPlan={setPlan} toplam={advance.toplam_tutar} />
        </div>
        <div className="p-4 border-t flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 rounded-lg border border-slate-200 text-sm font-semibold">İptal</button>
          <button onClick={save} disabled={!ok || saving} data-testid="advance-plan-save"
            className="px-4 py-2 rounded-lg bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold disabled:opacity-50">Planı Kaydet</button>
        </div>
      </div>
    </div>
  );
};
